<template>
  <div
    ref="topArticulosVendidosParent"
    class="panel panel-grid-item top-article"
    :class="{'bg-slate-300': editable}"
  >
    <!-- Modo editando -->
    <div class="bg-grey-300" style="height: 100%;" v-if="editable">
      <!-- Iconos acciones -->
      <div :class="{ 'vue-draggable-handle glyphicon glyphicon-move': editable }"></div>
      <div
        :class="{ 'vue-removable-handle glyphicon glyphicon-remove': editable }"
        @click="onClickEliminar()"
      ></div>
      <!-- //Iconos acciones -->
      <span
        class="pl-4 titulo-colapsado"
      >{{ $t("lang.home.toparticulosvendidos") }}</span>
    </div>
    <!-- //Modo editando -->
    <grid-layout
      v-else
      :layout.sync="contentLayout"
      :col-num="contentConfig.colNum"
      :row-height="contentConfig.rowHeight"
      :is-draggable="contentConfig.draggable"
      :is-resizable="contentConfig.resizable"
      :is-mirrored="contentConfig.mirrored"
      :vertical-compact="contentConfig.verticalCompact"
      :margin="contentConfig.margin"
      :use-css-transforms="contentConfig.useCssTransforms"
    >
      <grid-item
        v-for="itemContentLayout in contentLayout"
        :x="itemContentLayout.x"
        :y="itemContentLayout.y"
        :w="itemContentLayout.w"
        :h="itemContentLayout.h"
        :i="itemContentLayout.i"
        :key="itemContentLayout.i"
        class="py-2 px-2"
      >
  
         
             <v-avatar  size="36px" color="orange">
                <span class="white--text headline">{{ itemContentLayout.idComponent }}</span>
              </v-avatar>
        
          <v-img
            aspect-ratio="1"
            max-height="90"
            max-width="90"
            :src="photoSource(itemContentLayout.idart)"
            @error="imageLoadError"
            class="mr-2"
            style="float: left;"
          >
        </v-img>
        <div d-flex>
          <v-card-title class="text-uppercase h6 mb-0 pa-0 font-weight-medium primary-color">{{ itemContentLayout.data.nombre }}</v-card-title>
          <v-card-subtitle class="mb-0 d-flex grey--text text--darken-1"
          >PVP {{ itemContentLayout.data.pvpmin === itemContentLayout.data.pvpmax ? itemContentLayout.data.pvpmin : `${itemContentLayout.data.pvpmin} € ~ ${itemContentLayout.data.pvpmax}` }} €</v-card-subtitle>
          <v-card-subtitle class="mb-0 d-flex grey--text text--darken-1">Uds.{{ itemContentLayout.data.uds }}</v-card-subtitle>
        </div>
       
      </grid-item>
    </grid-layout>
  </div>
</template>
<script>
import { BCard } from "bootstrap-vue";
import { Util } from "@/api/Util";
const URL_SERVLET_IMAGENES = process.env.VUE_APP_URL_SERVLET_IMAGENES;
const INDEX_IMAGENES = process.env.VUE_APP_INDEX_IMAGENES;
const util = new Util();
export default {
  component: {
    "b-card": BCard
  },
  props: {
    editable: Boolean,
    config: Object,
    data: Array
  },
  data() {
    return {
      bip_item_id: Number(this.$route.query.tienda),
      gridLayoutHeight: 300, // altura del grid por defecto
      contentConfig: {
        colNum: 3, // Numero de columnas del grid
        rowHeight: 180, // Altura (pxs) de cada fila del grid
        draggable: false, // Variable que permite arrastrar los elementos
        resizable: false, // Variable que permite cambiar el tamanho de los elementos
        mirrored: false,
        verticalCompact: true,
        margin: [5, 5],
        useCssTransforms: true,
        responsive: true
      },
      contentLayout: [
        {
          x: 0,
          y: 0,
          w: 1,
          h: 1,
          i: "tav1",
          idComponent: 1,
          data: {
            pos: 1
          }
        },
        {
          x: 1,
          y: 0,
          w: 1,
          h: 1,
          i: "tav2",
          idComponent: 2,
          data: {
            pos: 2
          }
        },
        {
          x: 2,
          y: 0,
          w: 1,
          h: 1,
          i: "tav3",
          idComponent: 3,
          data: {
            pos: 3
          }
        },
        {
          x: 0,
          y: 1,
          w: 1,
          h: 1,
          i: "tav4",
          idComponent: 4,
          data: {
            pos: 4
          }
        },
        {
          x: 1,
          y: 1,
          w: 1,
          h: 1,
          i: "tav5",
          idComponent: 5,
          data: {
            pos: 5
          }
        },
        {
          x: 2,
          y: 1,
          w: 1,
          h: 1,
          i: "tav6",
          idComponent: 6,
          data: {
            pos: 6
          }
        }
      ]
    };
  },
  created() {
    this.populateData();
  },
  watch: {
    data: {
      handler(n, o) {
        if (o === undefined || n !== o) {
          this.populateData();
        }
      },
      deep: true
    }
  },
  methods: {
    onClickEliminar() {
      if (this.config.id !== undefined && this.config.id != null) {
        this.$emit("eliminartoparticulosvendidos", this.config.id);
      }
    },
    populateData() {
      // Vaciamos el data del contentlayout
      for (let i = 0; i < this.contentLayout.length; i++) {
        this.contentLayout[i].data = new Object();
      }

      // Y lo volvemos a rellenar
      if (
        this.data !== null &&
        this.data !== undefined &&
        this.data.length > 0
      ) {
        for (let j = 0; j < this.data.length; j++) {
          this.contentLayout[j].idart = this.data[j].mmart_id;
          this.contentLayout[j].data.nombre = this.data[j].mmart_desc;
          this.contentLayout[j].data.pvpmin = this.data[j].pvpmin;
          this.contentLayout[j].data.pvpmax = this.data[j].pvpmax;
          this.contentLayout[j].data.uds = this.data[j].unidades;
        }
      }
    },
    /**
     * Al intetar cargar la imagen de los articulos, si salta error llegara a este metodo, que devolvera la imagen por defecto
     */
    imageLoadError(event) {
      util.mostrarEnConsola(
        "TopArticulosVendidos - photoSource",
        "Error obteniendo la imagen",
        "ERROR"
      );
      event.target.src = require(`@/assets/images/item_1.jpg`);
    },
    photoSource: function(idart) {
      if (
        idart !== null &&
        idart !== undefined &&
        idart !== 0 &&
        !isNaN(idart)
      ) {
        return `${URL_SERVLET_IMAGENES}${idart}&index=${INDEX_IMAGENES}`;
      } else {
        return require(`@/assets/images/item_1.jpg`);
      }
    }
  }
};
</script>